// check if the device is an apple device
export const checkIsApple = () => {
  return /Mac|iPod|iPhone|iPad/.test(navigator.userAgent);
};
